import React, {useEffect, useState} from 'react';
import axios from "axios";
import {useStores} from "../../../stores/Context";
import {useParams} from "react-router-dom";
import BtnAction from "../../../boiteAOutils/BtnAction";
import ModalPrimary from "../../../boiteAOutils/ModalPrimary";
import BtnSvg from "../../../boiteAOutils/BtnSvg";

const ParametresGestionEquipes = () => {
    const {ent} = useParams();
    const {widgetStore} = useStores();
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + widgetStore.getCookie("current_apiToken");

    const [load, setLoad] = useState(true);
    const [teams, setTeams] = useState('');
    const [newTeam, setNewTeam] = useState('');
    const [showNewTeam, setShowNewTeam] = useState(false)
    const [isEditTeam, setIsEditTeam] = useState({id:'', rename: ''});
    const [isDeleteTeam, setIsDeleteTeam] = useState('');

    useEffect(() => {
        if (load) {
            axios.get(process.env.REACT_APP_API_URL + '/api/getListeQuartsTotem/' + widgetStore.idTotem).then((res) => {
                setTeams(res.data);
                setLoad(false);
            })
        }
    }, [load]);
    const handleAddTeam = () => {
        if (newTeam) {
            axios.post(process.env.REACT_APP_API_URL + '/api/addQuartTotem', {
                id_totem: widgetStore.idTotem,
                nom: newTeam
            }).then(() => {
                setLoad(true);
                setNewTeam('');
                setShowNewTeam(false)
            })
        }
    }

    const handleUpdateTeam = () => {
       if (isEditTeam.rename) {
           axios.post(process.env.REACT_APP_API_URL + '/api/updateQuartById', {
               id: isEditTeam.id,
               nom: isEditTeam.rename
           }).then(() => {
               setLoad(true);
               setIsEditTeam({...isEditTeam, id: '', rename: ''});
           })
       }
    }

    const handleDeleteTeam = () => {
        if (isDeleteTeam) {
            axios.post(process.env.REACT_APP_API_URL + '/api/deleteQuartById', {
                id: isDeleteTeam
            }).then(() => {
                setLoad(true);
                setIsDeleteTeam('');
            });
        }
    }

    return (
        <div>

            <div className={"parametreContentTitre"}>
                <h4 className={"parametreTitre4"}>Liste des validations</h4>
            </div>
            <div className={"parametreEquipesContent"}>

                <div className={"parametreEquipesContentListe"}>
                    {
                        teams ? (
                            teams.map((data) => (
                                <div style={{display: 'flex', alignItems: 'center', gap: '20px'}}>
                                    {
                                        isEditTeam.id === data.id ? (
                                            <div key={data.id} style={{
                                                display: 'flex',
                                                padding: "10px 17px 10px 10px",
                                                alignItems: 'center',
                                                gap: '25px'
                                            }}>
                                                <input className={"parametreEquipesContentInputAdd"} type={"text"}
                                                       value={isEditTeam.rename}
                                                       onChange={(e) => setIsEditTeam({
                                                           ...isEditTeam,
                                                           rename: e.target.value
                                                       })}
                                                />
                                                
                                                <div onClick={() => handleUpdateTeam()}
                                                     style={{cursor: "pointer"}}>
                                                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#00B0FF"
                                                         xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M4 12.6111L8.92308 17.5L20 6.5" stroke="#000000"
                                                              stroke-width="2.5" stroke-linecap="round"
                                                              stroke-linejoin="round" stroke="#00B0FF"/>
                                                    </svg>
                                                </div>

                                                <div onClick={() => setIsEditTeam({...isEditTeam, id: '', rename: ''})}
                                                     style={{cursor: "pointer"}}>
                                                <svg width="40" height="41" viewBox="0 0 40 41" fill="none"
                                                         xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M10 10.499L31.2903 31.7893" stroke="#002335"
                                                              stroke-width="4" stroke-linecap="round"
                                                              stroke-linejoin="round"/>
                                                        <path d="M10 31.7891L31.2903 10.4987" stroke="#002335"
                                                              stroke-width="4" stroke-linecap="round"
                                                              stroke-linejoin="round"/>
                                                    </svg>
                                                </div>
                                            </div>
                                        ) : (
                                            <div style={{
                                                display: 'flex',
                                                padding: "10px 17px 10px 10px",
                                                alignItems: 'flex-start',
                                                gap: '73px'
                                            }}>
                                                <span className={"parametreEquipesContentListeName"}>{data.nom}</span>

                                                <BtnSvg onClick={() => setIsEditTeam({
                                                    ...isEditTeam,
                                                    id: data.id,
                                                    rename: data.nom
                                                })} svg={'crayon'} width={30} height={30}/>

                                                <BtnSvg svg={'corbeille'} width={30} height={31} onClick={() => setIsDeleteTeam(data.id)}/>
                                            </div>
                                        )
                                    }


                                </div>
                            ))
                        ) : 'Aucune équipes définies'

                    }
                </div>

                {
                    showNewTeam ? (
                        <div className={"parametreEquipesContentAdd"}>
                            <input className={"parametreEquipesContentInputAdd"} type={"text"}
                                   placeholder={"Nommer la nouvelle validation"}
                                   value={newTeam}
                                   onChange={(e) => setNewTeam(e.target.value)}
                            />
                            <div onClick={handleAddTeam}>
                                <svg width="31" height="31" viewBox="0 0 31 31" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.2051 28.9102L15.2051 2.50049" stroke="#00B0FF" strokeWidth="4"
                                          strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M2 15.7051L28.4097 15.7051" stroke="#00B0FF" strokeWidth="4"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"/>
                                </svg>
                            </div>
                        </div>
                    ) : (
                        <BtnAction onClick={() => setShowNewTeam(true)}>
                            + Ajouter une validation
                        </BtnAction>
                    )
                }

            </div>

            {
                isDeleteTeam ? (
                    <ModalPrimary
                        textTitle={"Êtes-vous sur de vouloir supprimer la validation ?"}
                        textBtnValidate={"Supprimer la validation"}
                        textBtnCancel={"Revenir"}
                        onCancel={() => setIsDeleteTeam('')}
                        onValidate={handleDeleteTeam}
                    />
                ) : null
            }

        </div>
    );
};

export default ParametresGestionEquipes;